import "core-js/modules/es.number.constructor.js";
export default {
  name: 'ConfirmPopover',
  props: {
    title: String,
    content: String,
    confirmText: {
      type: String,
      default: '确定'
    },
    cancelText: {
      type: String,
      default: '取消'
    },
    width: {
      type: [String, Number],
      default: 250
    },
    placement: {
      type: String,
      default: 'top'
    },
    trigger: {
      type: String,
      default: 'click'
    },
    popperClass: {
      type: String,
      default: ''
    },
    appendToBody: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      visible: false,
      loading: false
    };
  },
  computed: {
    isAli: function isAli() {
      return this.form.dataSource === 'ALIPAY';
    }
  },
  methods: {
    cancel: function cancel() {
      this.visible = false;
      this.loading = false;
      this.$emit('cancel');
    },
    confirm: function confirm() {
      this.loading = true;
      this.$emit('confirm', this.confirmCallback);
    },
    confirmCallback: function confirmCallback(success) {
      this.loading = false;
      if (success) {
        this.visible = false;
      }
    }
  }
};